import * as React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Button, Chip, TableCell, TableRow } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

export function RowPromotion(props) {
  const {
    row,
    setSelectedPromotions,
    setShowModalEditPromotion,
    setShowModalDetailsPromotion,
    setShowModalDeletePromotion,
  } = props;
  const [open, setOpen] = React.useState(false);
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.nameEstablishment ?? "---"}
        </TableCell>
        <TableCell align="center">{row?.discount ?? "---"}</TableCell>
        <TableCell align="center">{row?.description ?? "---"}</TableCell>
        <TableCell align="center">
          <Chip
            label={row?.status === "active" ? "Activa" : "Inactiva "}
            style={{
              backgroundColor:
                row?.status === "active"
                  ? "rgb(5,193,104,20%)"
                  : "rgba(255,90,101,20%)",
              color: row?.status === "active" ? "#14CA74" : "#FF5A65",
            }}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Box
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  gap: 4,
                  padding: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  startIcon={<InfoIcon />}
                  onClick={() => {
                    setSelectedPromotions(row);
                    setShowModalDetailsPromotion(true);
                  }}
                >
                  Detalles
                </Button>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  startIcon={<EditIcon />}
                  onClick={() => {
                    setSelectedPromotions(row);
                    setShowModalEditPromotion(true);
                  }}
                >
                  Editar
                </Button>
                <Button
                  variant="outlined"
                  color="waithe"
                  startIcon={<DeleteIcon />}
                  onClick={() => {
                    setSelectedPromotions(row);
                    setShowModalDeletePromotion(true);
                  }}
                >
                  Eliminar Promoción
                </Button>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
